import type { Config } from '@grandvisionhq/shipping'

export const getDeliveryIndicatorConfig = (): Config => ({
  inventoryChannels: {
    '6cec74b3-cd19-4aa4-8939-2084d1d83b8b': {
      // online-store TEST
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    '68ccfe7a-a85d-4e9e-9f00-f4e50b82dc4a': {
      // online-store ACCT
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    '40e76ed6-c502-49a5-b3d9-44f96db807f2': {
      // online-store PROD
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
  },
  missingInventoryChannelStrategy: {
    expectedDeliveryDays: '8+',
  },
  nextDayDeliveryTimeLimit: '18:00',
  productTypeDeliveryConfig: [
    {
      type: 'GLASSES_BUNDLE',
      expectedDeliveryDays: '7-10',
    },
    {
      type: 'NON_PRESCRIPTION_BUNDLE',
      expectedDeliveryDays: '5',
    },
    {
      type: 'CONTACT_LENSES',
      expectedDeliveryDays: '3',
    },
    {
      type: 'REGULAR',
      expectedDeliveryDays: '1',
    },
  ],
})
